import DateInput from './DateInput'
import DateInputField from './DateInputWithField'
import { withValidationFields } from '../withField'

const DateInputWithValidation = withValidationFields(DateInput)

export { isValidDate } from './utils'
export { DateInputField, DateInputWithValidation }
export default DateInput
